// @flow

import React, { useEffect, useState } from "react";
import { translate } from "../../base/i18n";
import { getBaseConfig } from "../Utils";

const _SNS = 'deep-linking-mobile';
const _TNS = 'deepLinking';

declare var interfaceConfig: Object;

const MobileDeepLinking = (props) => {

    const [deepLinkUrl, setDeepLinkUrl] = useState('')

    useEffect(() => {
        deepLink();
    }, [])

    const deepLink = async () => {
        const key = "AIzaSyBsVCWRUPBvVxj_hGproQJvS8qK_ckZjN4";
        const firebaseUrl = "https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=" + key;

        let path = window.location;

        const deeplingkingUrl = getBaseConfig("deeplinkingLink");

        const iosBundle = deeplingkingUrl?.ios?.key;
        const androidBundle = deeplingkingUrl?.android?.key;

        const iosLink = deeplingkingUrl?.ios?.link;
        const androidLink = deeplingkingUrl?.android?.link;
        const iosId = deeplingkingUrl?.ios?.id;

        const deepLinkBase = deeplingkingUrl.shortLink;
        const payload = {
            "dynamicLinkInfo": {
                "domainUriPrefix": deepLinkBase,
                "link": deepLinkBase + "?link=" + path + "&apn=" + androidBundle + "&isi=" + iosId + "&ibi=" + iosBundle + "&ifl=" + iosLink + "&efr=1"
            }
        }

        fetch(firebaseUrl, {
            method: "POST",
            body: JSON.stringify(payload)
        })
            .then(e => e.json())
            .then(e => {
                if (e.hasOwnProperty("shortLink")) {
                    setDeepLinkUrl(e.shortLink);
                    console.log("Deep link", e.shortLink)
                }
            })
            .catch(e => console.log("ddddddddddddddd ", e))
    }

    const { HIDE_DEEP_LINKING_LOGO, NATIVE_APP_NAME, SHOW_DEEP_LINKING_IMAGE } = interfaceConfig;

    const { t } = props;


    return (
        <div className={_SNS}>
            <div className='header'>
                {
                    HIDE_DEEP_LINKING_LOGO
                        ? null
                        : <img
                            alt={getBaseConfig("name")}
                            className='logo'
                            src={getBaseConfig("smallLogo")} />
                }
            </div>
            <div className={`${_SNS}__body`}>
                {
                    SHOW_DEEP_LINKING_IMAGE
                        ? <img
                            alt={getBaseConfig("name")}
                            className='image'
                            src={getBaseConfig("smallLogo")} />
                        : null
                }
                <p className={`${_SNS}__text`}>
                    {t(`${_TNS}.appNotInstalled`, { app: getBaseConfig("name") })}
                </p>
                <a
                    href={deepLinkUrl}
                >
                    <button className={`${_SNS}__button ${_SNS}__button_primary`}>
                        Continue to the app
                    </button>
                </a>
            </div>
        </div>
    )
}

export default translate(MobileDeepLinking);

